import type { FaireProductEntity } from "../../entity_types/product";

export const p_azahmnjkwz: FaireProductEntity = {
  token: "p_azahmnjkwz",
  type: "product",
  name: "Thank Ewe Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/5e4b8a037ed4a47e9358dee5b333931b507da2f53c472d27cafbb680f5728c42.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/775ef282a785756b66d72248b84238b88a460097e45f50f5c81af19ecb5835b3.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:53.285Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
